import type { StateKey } from '@angular/core'
import { Injectable, TransferState, inject, makeStateKey } from '@angular/core'

import type { TranslateLoader, TranslationObject } from '@ngx-translate/core'
import type { Observable } from 'rxjs'
import { from, of, tap } from 'rxjs'

@Injectable()
export class JsonTranslateLoader implements TranslateLoader {
  private readonly transferState = inject(TransferState)

  public getTranslation(lang: string): Observable<TranslationObject> {
    try {
      return from(import(`../../assets/i18n/${lang}.json`)).pipe(
        tap(data => {
          // Here we save the translations in the transfer-state
          const key: StateKey<object> = makeStateKey<object>(
            'transfer-translate-' + lang
          )
          this.transferState.set(key, data)
        })
      )
    } catch {
      console.error('Missing translation file for language: ', lang)
      return of({})
    }
  }
}
